import {INTERNAL_ANALYTICS} from './serve/consts';
import {get, set} from './serve/localStorage';

type INTERNAL_ANALYTICS_CONFIG = {
  uuid: string;
  abtests?: string[];
};

export function getConfig() {
  return get<INTERNAL_ANALYTICS_CONFIG>(INTERNAL_ANALYTICS);
}

export function setConfig(uid: INTERNAL_ANALYTICS_CONFIG): void {
  set(INTERNAL_ANALYTICS, uid);
}
